<template>
    <div class="profile-dashboard">
      <div v-if="loadingProfile">
        Loading profile...
      </div>
      <div v-else-if="profileError">
        {{ profileError }}
      </div>
      <div v-else>
        <ProfileAnnouncement/>
        <h1>{{ greeting }}, {{ userProfile.firstName }}</h1>
        <!-- Insert additional widgets as needed -->
        <div class="widgets">
          <div class="left-column">
            <ProfileLatestUpdate/>
          </div>
          <div class="right-column">
            <ProfileAssignedProjects/>
            <ProfileFollowedProjects/>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ProfileLatestUpdate from "./ProfileLatestUpdate.vue";
  import ProfileDashboardLogic from "./ProfileDashboardLogic.js";
  import ProfileFollowedProjects from "./ProfileFollowedProjects.vue";
  import ProfileAnnouncement from "./ProfileAnnouncement.vue";
  import ProfileAssignedProjects from "./ProfileAssignedProjects.vue";
  
  export default {
    name: "ProfileDashboard",
    mixins: [ProfileDashboardLogic],
    components: {
      ProfileLatestUpdate,
      ProfileFollowedProjects,
      ProfileAnnouncement,
      ProfileAssignedProjects
    },
    computed: {
      greeting() {
        const hour = new Date().getHours();
        if (hour < 12) {
            return "🥰 Good morning";
        } else if (hour < 17) {
            return "☺️ Good afternoon";
        } else if (hour < 18) {
            return "🙂‍↕️ Good evening";
        } else if (hour < 19) {
            return "😧 Better not be working late";
        } else {
            return "😵 What are you still doing here";
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .profile-dashboard {
    max-width: 1200px; /* Set a maximum width */
    margin: 0 auto;    /* Center the container horizontally */
    min-height: 100vh;
    padding: 2rem;
  }
  .profile-dashboard h1 {
    margin-bottom: 2rem;
    color: #111827;
    padding-left: 15px;
  }

  .widgets {
    display: flex;
    gap: 1.5rem; /* Space between columns */
    justify-content: center; /* Center the columns as a group */
}

  .left-column,
  .right-column {
    /* Remove flex: 1 so they don’t stretch to fill extra space */
    flex: 0 1 auto;
    /* Optionally, set a max-width for each column if needed */
}
  </style>
  